import { makeStyles } from 'vendor/material';

export const useCanvasAppStyles = makeStyles((theme) => ({
  canvasAppContainer: {
    height: '100vh',
    width: '100vw',
  },
}));
